import VideoCarousel from './VideoCarousel';

export default VideoCarousel;
